import { Throwable } from "@wss/error-tracking/throwable";
import { toError } from "@wss/error-tracking/utils";

const getStockCount = async (
  itemNumberId: number,
  isConsumable: boolean,
  vendorCode: string,
): Promise<Throwable<number>> => {
  const endpointUrl = `/api/productdetails/inventory/stockcount/?id=${itemNumberId}${
    isConsumable ? "&consumable=true" : ""
  }&code=${vendorCode || ""}`;
  try {
    const response = await fetch(endpointUrl);
    const stockCount = await response.json<number>();
    return { isError: false, value: stockCount };
  } catch (e) {
    const error = new Error("Error in getStockCount", {
      cause: toError(e),
    });

    return { error, isError: true };
  }
};

export default getStockCount;
